import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { ClientWarranty, RequestPutWarrantieConstruccion, WarrantyToNewMinuteVM} from '../../interface/company-client.interface';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import Swal from 'sweetalert2';
import { ServiceInfoClientService } from '../../service/service-info-client.service';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { WarrantiesService } from '../../../service/warranties.service';
import { IssueWarrantyDTO, RequestPutWarrantieBuild } from '../../../warranties/interfaces/warranty.interface';

@Component({
  selector: 'app-client-pending-warranties-table',
  templateUrl: './client-pending-warranties-table.component.html',
  styleUrls: ['./client-pending-warranties-table.component.scss'],
})
export class ClientPendingWarrantiesTableComponent implements OnInit, AfterViewInit{
  @Input() pendingWarranties: ClientWarranty[];
  @Input() currentSGRScoringState: number;
  @Output() warrantiesForMinute = new EventEmitter<WarrantyToNewMinuteVM[]>();
  @Output() sendBoolean: EventEmitter<boolean> = new EventEmitter();
  @Output() warrantyToUpdateAmount: EventEmitter<ClientWarranty> = new EventEmitter();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public closeModal: boolean = false;
  public permisionApprovedWarranty: boolean = false;
  public permisionRejectWarranty: boolean = false;
  public text: string = '';
  public dataSource: MatTableDataSource<ClientWarranty>;
  public selection = new SelectionModel<ClientWarranty>(
    true, [], false, (w1, w2) => w1.warrantyId === w2.warrantyId);
  public war: WarrantyToNewMinuteVM[] = [];
  public displayCols = [
    'selectionColumn',
    'warrantyType',
    'insuranceCompany',
    'createdAt',
    'tender',
    'amount',
    'amountType',
    'cost',
    'nameTenderBuyer',
    'requestDate',
    'endDate',
    'tasa',
    'insuranceBroker',
    'isForBuilding',
    'contractAmount'
  ];

  constructor(private serviceWarranty: ServiceInfoClientService, private authService: AuthService, private warrantiesService: WarrantiesService) {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    if (this.currentSGRScoringState == 1) {
      this.text = `Este cliente se encuentra rechazado por riesgo`;
    }
    this.setDataSource();
    this.permisionApprovedWarranty =
      this.authService.ValidateUserPermission('ApprovedWarranty');
      
    this.permisionRejectWarranty =
      this.authService.ValidateUserPermission('RejectWarranty');
  }

  private setDataSource() {
    this.dataSource.data = this.pendingWarranties;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  createMinuteWithWarranties() {
    console.log(this.selection.selected);
    const warrantiesForNewMinute: WarrantyToNewMinuteVM[] =
      this.selection.selected.map((w) => {
        return <WarrantyToNewMinuteVM>{
          warrantyId: w.warrantyId,
          warrantyType: w.warrantyType,
          amount: w.amount,
          amountType: w.amountType,
          cost: w.cost,
          insuranceCompany: w.insuranceCompany,
          insuranceBroker: w.insuranceBroker,
          requestDate: w.requestDate,
          endDate: w.endDate,
        };
      });
    this.warrantiesForMinute.emit(warrantiesForNewMinute);
  }

  createMinute(warranty: WarrantyToNewMinuteVM) {
    const warranties: WarrantyToNewMinuteVM[] = [];
    warranties.push(warranty);
    this.warrantiesForMinute.emit(warranties);
  }

  approved(warrantyId: number, warrantyType: string, amount: number, tender: number, isForBuilding: string): void {
    const email = this.authService.getEmailIdentifier();
    let formatter = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      currencyDisplay: 'symbol',
    });

    let warrantiesText = `
      <table style="margin: 0 auto;">
        <tr>
          <th style="padding: 8px 12px;">Garantía</th>
          <th style="padding: 8px 12px;">Monto</th>
          <th style="padding: 8px 12px;">Id Licitacion</th>
          <th style="padding: 8px 12px;">Construccion</th>
        </tr>

        <tr>
          <td style="padding: 8px 12px;">${warrantyType}</td>
          <td style="padding: 8px 12px;">${formatter.format(amount)}</td>
          <td style="padding: 8px 12px;">${tender}</td>
          <td><input type="checkbox" id="approvedCheckbox" ${isForBuilding == 'Si' ? 'checked' : ''}></td>
        </tr> 
      </table>  
    `;

    Swal.fire({
      icon: 'question',
      title: `¿Deseas aprobar esta Garantía?<br> <span style ="color:red; font-size: 18px;">${this.text}</span>`,
      html: `${warrantiesText}`,
      width: 710,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
      confirmButtonText: 'Aprobar',
      timerProgressBar: true,
    }).then((r) => {
      if (r.isConfirmed) {
        Swal.showLoading();
        const checkbox = document.getElementById('approvedCheckbox') as HTMLInputElement;
        const isChecked = checkbox.checked;

        this.aproveWarrantie(warrantyId, isChecked);
      }
    });
  }

  aproveWarrantie(warrantyId: number, isBuilding: boolean) {
    const email = this.authService.getEmailIdentifier();
    this.serviceWarranty
    .postApprovedWarranties(email, warrantyId, isBuilding)
    .subscribe({
      next: (e) => {
        console.log(e);
        Swal.fire({
          title: 'Garantia Aprobada',
          icon: 'success',
          heightAuto: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.sendBoolean.emit((this.closeModal = true));
            // this.dialogRef.close(this.closeModal);
          }
        });
      },
      error: (error) => {
        console.log(error);
        Swal.fire({
          title: error.error.message,
          text: 'No fue posible aprobar esta garantia',
          icon: 'error',
          showConfirmButton: true,
          heightAuto: false,
          confirmButtonText: 'Cerrar',
        });
      },
    });
  }


  rejectWarranty(warrantyId: number, warrantyType: string, amount: number, tender:number): void {
    const email = this.authService.getEmailIdentifier();

    let formatter = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      currencyDisplay: 'symbol',
    });

    let warrantiesText = `
      <table style="margin: 0 auto;">
        <tr>
          <th style="padding: 8px 12px;">Garantía</th>
          <th style="padding: 8px 12px;">Monto</th>
          <th style="padding: 8px 12px;">Id Licitacion</th>
        </tr>

        <tr>
          <td style="padding: 8px 12px;">${warrantyType}</td>
          <td style="padding: 8px 12px;">${formatter.format(amount)}</td>
          <td style="padding: 8px 12px;">${tender}</td>
        </tr> 
      </table>
    `;

    Swal.fire({
      icon: 'question',
      title: `¿Deseas<span style ="color:red;"> rechazar</span> esta Garantía?<br> <span style ="color:red; font-size: 18px;">${this.text}</span>`,
      html: warrantiesText,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
      confirmButtonText: 'Rechazar',
      timerProgressBar: true,
    }).then((r) => {
      if (r.isConfirmed) {
        Swal.showLoading();
        this.serviceWarranty.postRejectWarranties(warrantyId).subscribe({
          next: (e) => {
            console.log(e);
            Swal.fire({
              title: 'Garantia Rechazada ',
              icon: 'success',
              heightAuto: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.sendBoolean.emit((this.closeModal = true));
                // this.dialogRef.close(this.closeModal);
              }
            });
          },
          error: (error) => {
            console.log(error);
            Swal.fire({
              title: error.error.message,
              text: 'No fue posible rechazar esta garantia',
              icon: 'error',
              showConfirmButton: true,
              heightAuto: false,
              confirmButtonText: 'Cerrar',
            });
          },
        });
      }
    });
  }

  approvedMultiWarranties() {
    this.war = this.selection.selected.map((w) => {
      return <WarrantyToNewMinuteVM>{
        warrantyId: w.warrantyId,
        warrantyType: w.warrantyType,
        amount: w.amount,
        tender: w.tender,
        build: w.isForBuilding
      };
    });

    /*const list: RequestPutWarrantieBuild[] = this.selection.selected.map((w) => ({
      warrantyId: w.warrantyId,
      isConstruccion: w.isForBuilding == 'si',
    }));*/

    const email = this.authService.getEmailIdentifier();
    let formatter = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      currencyDisplay: 'symbol',
    });

    let warrantiesText = `
      <table style="margin: 0 auto;">
      <tr>
        <th style="padding: 8px 12px;">Garantía</th>
        <th style="padding: 8px 12px;">Monto</th>
        <th style="padding: 8px 12px;">Id Licitaciones</th>
        <th style="padding: 8px 12px;">Construccion</th>
      </tr>
    `;

    this.war.map((e, i) => {
      warrantiesText += `
        <tr>
          <td style="padding: 8px 12px;">${e.warrantyType}</td>
          <td style="padding: 8px 12px;">${formatter.format(e.amount)}</td>
          <td style="padding: 8px 12px;">${e.tender}</td>
          <td><input type="checkbox" class="approveCheckbox" data-index="${i}" ${e.build == 'Si' ? 'checked' : ''}></td>
        </tr>    
      `;
    });
    warrantiesText += `
      </table>
    `;

    Swal.fire({
      icon: 'question',
      title: `¿Deseas aprobar estas Garantías?<br> <span style ="color:red; font-size: 18px;">${this.text}</span>`,
      html: `${warrantiesText}`,
      width: 710,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
      confirmButtonText: 'Aprobar',
      timerProgressBar: true,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const checkboxes = document.querySelectorAll('.approveCheckbox') as NodeListOf<HTMLInputElement>;
        checkboxes.forEach((checkbox) => {
          const index = parseInt(checkbox.getAttribute('data-index')!, 10);
          this.war[index].build = checkbox.checked ? 'Si' : 'No' ;
        });
        return this.war;
      },
    }).then((r) => {
      if (r.isConfirmed) {
        Swal.showLoading();
            this.war.forEach((e) => {
              this.serviceWarranty
              .postApprovedWarranties(email, e.warrantyId, (e.build == 'Si'))
              .subscribe({
                next: (e) => {
                  Swal.showLoading();
                  Swal.fire({
                    title: 'Garantía Aprobada ',
                    icon: 'success',
                    heightAuto: false,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.sendBoolean.emit((this.closeModal = true));
                    }
                  });
                },
                error: (error) => {
                  console.log(error);
                  Swal.fire({
                    title: error.error.message,
                    text: 'No fue posible aprobar esta Garantía',
                    icon: 'error',
                    showConfirmButton: true,
                    heightAuto: false,
                    confirmButtonText: 'Cerrar',
                  });
                },
              });
            });
      }
    });
  }

  rejectMultiWarranties() {
    const w: WarrantyToNewMinuteVM[] = this.selection.selected.map((w) => {
      return <WarrantyToNewMinuteVM>{
        warrantyId: w.warrantyId,
        warrantyType: w.warrantyType,
        amount: w.amount,
        tender:w.tender
      };
    });
    let formatter = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      currencyDisplay: 'symbol',
    });

    const email = this.authService.getEmailIdentifier();
    let warrantiesText = `
      <table style="margin: 0 auto;">
      <tr>
        <th style="padding: 8px 12px;">Garantía</th>
        <th style="padding: 8px 12px;">Monto</th>
        <th style="padding: 8px 12px;">Id Licitacion</th>
      </tr>
    `;

    w.map((e) => {
      warrantiesText += `
        <tr>
          <td style="padding: 8px 12px;">${e.warrantyType}</td>
          <td style="padding: 8px 12px;">${formatter.format(e.amount)}</td>
          <td style="padding: 8px 12px;">${e.tender}</td>
        </tr>    
      `;
    });

    warrantiesText += `
      </table>
    `;

    Swal.fire({
      icon: 'question',
      title: `¿Deseas<span style ="color:red;"> rechazar</span> estas Garantías?<br> <span style ="color:red; font-size: 18px;">${this.text}</span>`,
      html: warrantiesText,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
      confirmButtonText: 'Rechazar',
      timerProgressBar: true,
      showLoaderOnConfirm: true,
    }).then((r) => {
      if (r.isConfirmed) {
        Swal.showLoading();
        w.forEach((e) => {
          this.serviceWarranty.postRejectWarranties(e.warrantyId).subscribe({
            next: (e) => {
              Swal.showLoading();
              Swal.fire({
                title: 'Garantia Rechaza ',
                icon: 'success',
                heightAuto: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.sendBoolean.emit((this.closeModal = true));
                  // this.dialogRef.close(this.closeModal);
                }
              });
            },
            error: (error) => {
              console.log(error);
              Swal.fire({
                title: error.error.message,
                text: 'No fue posible rechazar esta garantia',
                icon: 'error',
                showConfirmButton: true,
                heightAuto: false,
                confirmButtonText: 'Cerrar',
              });
            },
          });
        });
      }
    });
  }

  updateWarrantyAmount(warranty: any) {
    this.warrantyToUpdateAmount.emit(warranty);
  }

}